// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uG-z","hovered":"vG-z","hoverImage":"wG-z","mainImage":"xG-z","imageNoBackground":"yG-z","fullSizeImage":"zG-z"};